import React, { useState } from "react";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import GreenBtn from "../cta/GreenBtn";

// 👇 Main Exported Component
export default function FormWrapper() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Ld67GwrAAAAACvJOkh2lGeIpF3ddT8yFPmviuYK"
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
    >
      <Form />
    </GoogleReCaptchaProvider>
  );
}

function Form() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateInputs = () => {
    const nameRegex = /^[A-Za-z\s]{2,}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^\d{7,14}$/;

    if (!nameRegex.test(formData.name)) {
      alert("Please enter a valid name.");
      return false;
    }

    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email address.");
      return false;
    }

    if (!mobileRegex.test(formData.mobile)) {
      alert("Phone number must be between 7 and 14 digits.");
      return false;
    }

    const wordCount = formData.message.trim().split(/\s+/).length;
    if (wordCount < 5) {
      alert("Please enter a message with at least 5 words.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateInputs()) return;

    if (!executeRecaptcha) {
      alert("reCAPTCHA not yet loaded. Please try again.");
      return;
    }

    try {
      const token = await executeRecaptcha("submit_form");

      const response = await fetch("https://vodote.com/send_email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, recaptcha_token: token }),
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message);
      } else {
        alert(`${result.message}: ${result.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="col">
        <input
          className="inputBox"
          type="text"
          name="name"
          placeholder="Your Name*"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="col">
        <input
          className="inputBox"
          type="email"
          name="email"
          placeholder="Your Email*"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="col">
        <input
          className="inputBox"
          type="tel"
          name="mobile"
          placeholder="Your Phone Number*"
          value={formData.mobile}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="col">
        <textarea
          className="inputBox"
          name="message"
          placeholder="Your Message*"
          value={formData.message}
          onChange={handleInputChange}
          rows="4"
          required
        />
      </div>
      <GreenBtn greenBtnText="Get A Callback" type="submit" />
      <p className="formText">By submitting my data I agree to be contacted</p>
    </form>
  );
}
